var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B9796523-E7F1-47BA-9444-F55FE58AB37D@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.-Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table-Elements",
    transform: "translate(-698.000000, -456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/24/delivery/cancelled",
    transform: "translate(698.000000, 456.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#B2C3C9",
    fillRule: "evenodd",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\uE5CD",
    fillOpacity: 0.96,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "16.1835938 17.2382812 17.2382812 16.1835938 13.0546875 12 17.2382812 7.81640625 16.1835938 6.76171875 12 10.9453125 7.81640625 6.76171875 6.76171875 7.81640625 10.9453125 12 6.76171875 16.1835938 7.81640625 17.2382812 12 13.0546875"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.2e20cadcc01b7bde53948e3be6462a30.svg";
export { ForwardRef as ReactComponent };